<template>
    <section
        class="features-split section"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="features-split-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <c-section-header :data="sectionHeader" class="center-content" />
                <div
                    class="split-wrap"
                    :class="[
                        invertMobile && 'invert-mobile',
                        invertDesktop && 'invert-desktop',
                        alignTop && 'align-top'
                    ]">
                    <div class="split-item reveal-scale-up">
                        <div class="split-item-content center-content-mobile">
                            <h3 class="mt-0 mb-16">
                                Customs Clearance &amp; Quarantine
                            </h3>
                            <p class="m-0">
                                Import declarations (N10 and SAC), tariff classification, duty and GST assessment, DAFF quarantine entries and CCID setup — prepared and lodged by our own ABF-licensed broker, not outsourced. 专业报关,自营持牌。
                            </p>
                        </div>
                        <div
                            class="split-item-image is-3d illustration-element-03"
                            :class="imageFill && 'split-item-image-fill'">
                            <c-image
                                :src="require('@/assets/images/Importation-image-01.jpg')"
                                alt="Customs clearance"
                                :width="528"
                                :height="396" />
                        </div>
                    </div>

                    <div class="split-item reveal-scale-up">
                        <div class="split-item-content center-content-mobile">
                            <h3 class="mt-0 mb-16">
                                Sea &amp; Air Freight
                            </h3>
                            <p class="m-0">
                                International sea and air freight to Australia with door-to-door options, weekend and public-holiday service, and shipment tracking right on this site. 海运空运,门到门。
                            </p>
                        </div>
                        <div
                            class="split-item-image is-3d illustration-element-04"
                            :class="imageFill && 'split-item-image-fill'">
                            <c-image
                                :src="require('@/assets/images/features-split-image-01.jpg')"
                                alt="Sea and air freight"
                                :width="528"
                                :height="396" />
                        </div>
                    </div>

                    <div class="split-item reveal-scale-up">
                        <div class="split-item-content center-content-mobile">
                            <h3 class="mt-0 mb-16">
                                Warehousing &amp; Last-Mile Delivery
                            </h3>
                            <p class="m-0">
                                Our 2,200 m&sup2; Perth warehouse handles storage, unpacking and dispatch, with sideloader access and crane-truck delivery for oversized cargo. 自营仓储,末端配送。
                            </p>
                        </div>
                        <div
                            class="split-item-image is-3d illustration-element-05"
                            :class="imageFill && 'split-item-image-fill'">
                            <c-image
                                :src="require('@/assets/images/features-split-image-02.jpg')"
                                alt="Warehousing and delivery"
                                :width="528"
                                :height="396" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionSplitProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
import CImage from '@/components/elements/Image.vue'

export default {
  name: 'CFeaturesSplit',
  components: {
    CSectionHeader,
    CImage
  },
  mixins: [SectionSplitProps],
  data() {
    return {
      sectionHeader: {
        title: "What We Do",
        paragraph:
          'From customs entry to final delivery, everything is handled in-house by one team.'
      }
    }
  }
}
</script>